import { makeStyles } from '@material-ui/core/styles';

export const useDetailTabsStyles = makeStyles(() => ({
  tabs: {
    '&.MuiTabs-root': {
      borderBottom: '1px solid #bcbcbc',
      marginRight: '-16px !important',
      marginLeft: '-16px !important',
    },
  },
  container: {
    backgroundColor: (props) => (props.mobile ? 'white' : '#f1f1f1'),
    width: '100%',
  },
}));
